import {JSX} from "react";

import "./styles/html-content.scss";

export interface HtmlContentProps {
    html: string;
    className?: string;
}

/**
 * Component for rendering and styling HTML content from API
 * Applies consistent typography and spacing to HTML elements
 */
export function HtmlContent({html, className = ""}: HtmlContentProps): JSX.Element {
    return <div className={`html-content ${className}`} dangerouslySetInnerHTML={{__html: html}} />;
}
